import React from 'react';

const PlayVideoButton: React.FC = props => (
  <svg
    width="88"
    height="60"
    viewBox="0 0 88 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="88" height="60" fill="#2277D1" fillOpacity="0.8" />
    <path
      d="M35 18L53.6667 30L35 42V18Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default PlayVideoButton;
